import { Fragment } from 'react';

import Icon from '../../../components/UI/MDC/Icon/Icon';
import Radio from '../../../components/UI/MDC/Radio/Radio';
import RadioSet from '../../../components/UI/MDC/Radio/RadioSet/RadioSet';
import classes from '../../../components/UI/Input/RadioButton/RadioButton.module.scss';
import * as utils from '../../../utils';

const YesNoRadioButton = props => {
	const { formDetails } = props;
	const showValidation = formDetails.validation.touched;
	const validity = showValidation
		? !(props.validationMessage && props.validationMessage.length > 0) &&
		  props.valid
		: true;
	const iconStyle = validity
		? 'validation__icon--valid'
		: 'validation__icon--invalid';
	const iconShape = validity ? 'check_circle_outline' : 'block';
	const combinedRadioButtonStyles = [];
	if (props.className) {
		combinedRadioButtonStyles.push(props.className);
	}
	return (
		<>
			<Fragment>
				<div
					className={utils.concatenateClassNames(
						['input__radio--full-width', 'input__radio__container'],
						classes
					)}
				>
					<Icon icon={iconShape} className={classes[iconStyle]} />
					<RadioSet changeHandler={props.onChange}>
						<Radio
							label={'Yes'}
							value={'Yes'}
							checked={props.value === 'Yes'}
						/>
						<Radio
							label={'No'}
							value={'No'}
							checked={props.value === 'No'}
						/>
					</RadioSet>
				</div>
			</Fragment>
		</>
	);
};

YesNoRadioButton.propTypes = {};

export default YesNoRadioButton;
